import SubscribeBackground from '@/assets/images/subscribe-bg.jpg'
import { PropsWithChildren } from 'react'

export default function SubscribeLayout({ children }: PropsWithChildren) {
  return (
    <div
      style={{
        backgroundImage: `url(${SubscribeBackground})`,
      }}
      className="flex bg-cover bg-center flex-col px-4 items-center justify-center min-h-screen py-12 bg-gray-50"
    >
      {children}
    </div>
  )
}
